import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchEmailByIdRequest,
  FetchEmailsRequest,
  FetchEmailStatsRequest,
  ResendEmailRequest,
  DeleteEmailRequest,
} from './types'
import {AxiosError} from 'axios'
import axios from 'axios'

// Use API_URL from environment, fallback to current domain
const API_URL = process.env.REACT_APP_API_URL || window.location.origin

// API URLs matching backend implementation
const fetchEmailsUrl = `${API_URL}/api/email/logs`
const fetchEmailByIdUrl = `${API_URL}/api/email/logs`
const fetchEmailStatsUrl = `${API_URL}/api/email/stats`
const resendEmailUrl = `${API_URL}/api/email/resend`
const deleteEmailUrl = `${API_URL}/api/email/logs`

export const fetchEmails = createAsyncThunk(
  'email/fetch',
  async (payload: FetchEmailsRequest, {rejectWithValue}) => {
    try {
      const queryParams = new URLSearchParams()
      queryParams.append('sortField', payload.sortField)
      queryParams.append('sortOrder', payload.sortOrder)
      queryParams.append('pageNumber', payload.pageNumber.toString())
      queryParams.append('pageCount', payload.pageCount.toString())
      
      if (payload.search && payload.search.trim() !== '') {
        queryParams.append('search', payload.search.trim())
      }
      if (payload.status && payload.status.length > 0) {
        queryParams.append('status', payload.status.join(','))
      }
      if (payload.emailType && payload.emailType.length > 0) {
        queryParams.append('emailType', payload.emailType.join(','))
      }
      if (payload.priority && payload.priority.length > 0) {
        queryParams.append('priority', payload.priority.join(','))
      }
      if (payload.startDate) {
        queryParams.append('startDate', payload.startDate)
      }
      if (payload.endDate) {
        queryParams.append('endDate', payload.endDate)
      }
      if (payload.recipient) {
        queryParams.append('recipient', payload.recipient)
      }

  const res = await axios.get(`${fetchEmailsUrl}?${queryParams.toString()}`)
  const {emails, totalPages, total} = res.data
      return {
        emails,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      // Debug log: show HTTP status and response body when available
      console.error('fetchEmails error', err.response?.status, err.response?.data || err.message)
      const message = err.response?.data?.fr || err.response?.data?.message
      return rejectWithValue({
        success: false,
        error: message || 'Failed to fetch emails',
      })
    }
  }
)

export const fetchEmailById = createAsyncThunk(
  'email/fetchById',
  async (payload: FetchEmailByIdRequest, {rejectWithValue}) => {
    try {
  const res = await axios.get(`${fetchEmailByIdUrl}/${payload.id}`)
  const email = res.data
      return {
        email,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      console.error('fetchEmailById error', err.response?.status, err.response?.data || err.message)
      const message = err.response?.data?.fr || err.response?.data?.message
      return rejectWithValue({
        success: false,
        error: message || 'Failed to fetch email',
      })
    }
  }
)

export const fetchEmailStats = createAsyncThunk(
  'email/fetchStats',
  async (payload: FetchEmailStatsRequest, {rejectWithValue}) => {
    try {
      const queryParams = new URLSearchParams()
      if (payload.startDate) {
        queryParams.append('startDate', payload.startDate)
      }
      if (payload.endDate) {
        queryParams.append('endDate', payload.endDate)
      }
      if (payload.groupBy) {
        queryParams.append('groupBy', payload.groupBy)
      }

      const res = await axios.get(`${fetchEmailStatsUrl}?${queryParams.toString()}`)
      const stats = res.data
      return {
        stats,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      console.error('fetchEmailStats error', err.response?.status, err.response?.data || err.message)
      const message = err.response?.data?.fr || err.response?.data?.message
      return rejectWithValue({
        success: false,
        error: message || 'Failed to fetch email statistics',
      })
    }
  }
)

export const resendEmail = createAsyncThunk(
  'email/resend',
  async (payload: ResendEmailRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(`${resendEmailUrl}/${payload.id}/resend`)
      const email = res.data
      return {
        email,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      console.error('resendEmail error', err.response?.status, err.response?.data || err.message)
      const message = err.response?.data?.fr || err.response?.data?.message
      return rejectWithValue({
        success: false,
        error: message || 'Failed to resend email',
      })
    }
  }
)

export const deleteEmail = createAsyncThunk(
  'email/delete',
  async (payload: DeleteEmailRequest, {rejectWithValue}) => {
    try {
      const res = await axios.delete(`${deleteEmailUrl}/${payload.id}`)
      const email = res.data
      return {
        email,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      console.error('deleteEmail error', err.response?.status, err.response?.data || err.message)
      const message = err.response?.data?.fr || err.response?.data?.message
      return rejectWithValue({
        success: false,
        error: message || 'Failed to delete email',
      })
    }
  }
)

